import { c as _c } from "react/compiler-runtime";
import { formatPrice, highestBid } from "@/lib/price";
import { cn } from "@/lib/utils";
export default function AuctionPriceTable(t0) {
  const $ = _c(14);
  const {
    salePrice,
    lastBidPrice,
    minPrice,
    openingPrice,
    className
  } = t0;
  let t1;
  if ($[0] !== lastBidPrice || $[1] !== minPrice) {
    t1 = highestBid(lastBidPrice, minPrice);
    $[0] = lastBidPrice;
    $[1] = minPrice;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    highest,
    bid,
    minVal
  } = t1;
  let t2;
  if ($[3] !== bid || $[4] !== className || $[5] !== highest || $[6] !== lastBidPrice || $[7] !== minPrice || $[8] !== minVal || $[9] !== openingPrice || $[10] !== salePrice) {
    const entries = [{
      key: "base",
      label: "Valor Base",
      value: salePrice
    }, {
      key: "opening",
      label: "Valor Abertura",
      value: openingPrice
    }, {
      key: "minimum",
      label: "Valor M\xEDnimo",
      value: minPrice,
      highlight: minVal === highest
    }, {
      key: "bid",
      label: "Lance mais alto",
      value: lastBidPrice,
      highlight: bid === highest
    }];
    let t3;
    if ($[12] !== className) {
      t3 = cn("flex flex-col w-full", className);
      $[12] = className;
      $[13] = t3;
    } else {
      t3 = $[13];
    }
    t2 = <div className={t3} data-sentry-component="AuctionPriceTable" data-sentry-source-file="AuctionPriceTable.tsx">{entries.map(_temp)}</div>;
    $[3] = bid;
    $[4] = className;
    $[5] = highest;
    $[6] = lastBidPrice;
    $[7] = minPrice;
    $[8] = minVal;
    $[9] = openingPrice;
    $[10] = salePrice;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
}
function _temp(t0) {
  const {
    key,
    label,
    value,
    highlight
  } = t0;
  return <div key={key} className={cn("flex w-full justify-between text-sm", highlight ? "font-semibold " : undefined)}><span>{label}:</span> <span>{formatPrice(value)}</span></div>;
}